<p-dialog header="{{ dialogType == 'view' ? 'Applied Credit' : 'Select Available Credits' }}" [(visible)]="displayCreditSelect" [modal]="true" 
[responsive]="true" [closable]="false" [style]="{ width: '60vw' }" [baseZIndex]="9999">
    <div class="card">
        <div class="p-grid">
            <div class="p-col-12">
                <p-table [value]="availableCredits" 
                    [(selection)]="selectedCredits"
                    selectionMode="multiple" 
                    (onRowSelect)="calTotalCredit($event)" 
                    (onRowUnselect)="calTotalCredit($event)">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Memo No.</th>
                            <th>Status</th>
                            <th>Create Date</th>
                            <th>Create By</th>
                            <th>Type</th>
                            <th>Total Amount</th>
                            <th>Applied Amount</th>
                            <th>Available Amount</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-creditMemo let-rowIndex="rowIndex">
                        <tr [pSelectableRow]="creditMemo" [pSelectableRowIndex]="rowIndex">
                            <td>{{ creditMemo.number }}</td>
                            <td>{{ creditMemo.creditMemoStatus }}</td>
                            <td>{{ creditMemo.creditMemoDate | date: "MM/dd/yyyy" }}</td>
                            <td>{{ creditMemo.createdByUser }}</td>
                            <td>{{ creditMemo.type }}</td>
                            <td>{{ creditMemo?.currencyCode ? creditMemo?.currencyCode : this.baseCurrency?.symbol}} {{ creditMemo.totalCreditAmount | customNumberFormat: fractionDigits}}</td>
                            <td>{{ creditMemo?.currencyCode ? creditMemo?.currencyCode : this.baseCurrency?.symbol}} {{ creditMemo.appliedAmount | customNumberFormat: fractionDigits}}</td>
                            <td>{{ creditMemo?.currencyCode ? creditMemo?.currencyCode : this.baseCurrency?.symbol}} {{ creditMemo.pendingCreditAmount | customNumberFormat: fractionDigits}}</td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="footer" let-creditMemo>
                        <tr>
                            <td colspan="7">
                                <div class="p-text-right">Total:</div>
                            </td>
                            <td>{{ creditAppliedTotal | customNumberFormat: fractionDigits }}</td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </div>
    <p-footer>
        <button type="button" pButton (click)="closeCreditSelectionModal()" label="Cancel" class="p-button-secondary"></button>
        <button type="button" pButton label="Apply" (click)="applySelectedCredit()" [disabled]="availableCredits?.length == 0 || selectedCredits?.length == 0 || !actionPerformed" *ngIf="dialogType != 'view'"></button>
    </p-footer>
</p-dialog>